import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';

import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { Load } from '../../../../actions/payment-terms.op.actions';
import { getOpenPlatformContractData } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/contracts.selectors';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

@Injectable()
export class LoadPaymentTermOpenPlatformCommandService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: string, formGroup: UntypedFormGroup): void {
    if (value) {
      this.store
        .pipe(
          select(getOpenPlatformContractData),
          filter((availableContracts) => !!availableContracts),
        )
        .subscribe((contracts) => {
          const productCode = formGroup.get(SpecFieldNames.PRODUCT_SELECTION).value;
          const contract =
            contracts &&
            contracts.availableContract &&
            contracts.availableContract[productCode] &&
            contracts.availableContract[productCode].find((item) => item.contractCode.replace(/^0+/, '') === value);
          if (!!contract) {
            this.store.dispatch(new Load(value));
          }
        });
    }
  }
}
